module.exports = __webpack_public_path__ + "img/slider-arrow-prev.3ad1b7be39ec8382c64181cf7f165b70.svg";